const PHONETIC_ENCODINGS = {
  PHONETIC_ENCODING_IPA: "IPA",
  PHONETIC_ENCODING_UNSPECIFIED: "Unspecified",
  PHONETIC_ENCODING_X_SAMPA: "X-SAMPA",
  PHONETIC_ENCODING_JAPANESE_YOMIGANA: "Japanese Yomigana",
  PHONETIC_ENCODING_PINYIN: "Pinyin",
};

const SingleEditorView = ({ item, onChange, isAdd = false }) => {
  return (
    <div className="grid grid-cols-2 gap-4 w-full">
      <input
        type="text"
        name="phrase"
        value={item.phrase}
        onChange={onChange}
        disabled={!isAdd}
        maxLength={100}
        placeholder="Phrase"
        className={`p-2 border border-gray-600 rounded w-full bg-transparent ${
          !isAdd ? "bg-gray-700 cursor-not-allowed" : ""
        }`}
      />
      <input
        type="text"
        name="encoded_phonetic_pronunciation"
        value={item.encoded_phonetic_pronunciation}
        onChange={onChange}
        placeholder="Encoded Phonetic Pronunciation"
        className="p-2 border border-gray-600 rounded w-full bg-transparent"
      />
      <select
        name="phonetic_encoding"
        value={item.phonetic_encoding}
        onChange={onChange}
        className="p-2 border border-gray-600 rounded w-full bg-transparent"
      >
        {Object.entries(PHONETIC_ENCODINGS).map(([key, label]) => (
          <option key={key} value={key}>
            {label}
          </option>
        ))}
      </select>
      <input
        type="text"
        name="simple_phonetic_pronunciation"
        value={item.simple_phonetic_pronunciation}
        onChange={onChange}
        placeholder="Simple Phonetic Pronunciation"
        className="p-2 border border-gray-600 rounded w-full bg-transparent"
      />
      <input
        type="text"
        name="comment"
        value={item.comment}
        onChange={onChange}
        placeholder="Comment"
        className="p-2 border border-gray-600 rounded w-full bg-transparent col-span-2"
      />
    </div>
  );
};

export default SingleEditorView;
